import { STATUS_ACCENT } from './statusStyles';

// The driver picker's options: one row per PERSON, not per driver+route
// pair. Records are route-shaped, so a driver who worked two routes appears
// in two of them; keying on the roster email folds those into one option and
// makes selection unambiguous. The universe is every credited driver on the
// scoped records — the same evidence rule composeDriverRecords applies — so
// a driver who stocked stops without being the last phone to ping is listed,
// and one who only stamped a stray ping is not.

// The status dot beside a person shows their most pressing route.
const STATUS_URGENCY = ['off-track', 'behind', 'on-track', 'completed'];
const moreUrgent = (statusA, statusB) => {
  const rankA = STATUS_URGENCY.indexOf(statusA);
  const rankB = STATUS_URGENCY.indexOf(statusB);
  if (rankA === -1) {
    return statusB;
  }
  if (rankB === -1) {
    return statusA;
  }
  return rankA <= rankB ? statusA : statusB;
};

/**
 * @param {Array} records composed driver records (route-shaped)
 * @returns {Array<{email: string, name: string, routeIds: string[],
 *   status: string|null}>} sorted by name
 */
export default function buildDriverOptions(records) {
  const byEmail = new Map();
  (records || []).forEach((record) => {
    (record.driverRoster || []).forEach(({ email, name }) => {
      if (!email) {
        return;
      }
      const option = byEmail.get(email) || {
        email,
        name,
        routeIds: [],
        status: null,
      };
      if (!option.routeIds.includes(record.routeId)) {
        option.routeIds.push(record.routeId);
      }
      option.status = moreUrgent(option.status, record.status);
      byEmail.set(email, option);
    });
  });
  return [...byEmail.values()].sort((first, second) =>
    first.name.localeCompare(second.name),
  );
}

// Keeps the picker's dot classes honest: only statuses with an accent color
// are ever set on an option.
export const OPTION_STATUSES = Object.keys(STATUS_ACCENT);
